/**
 * Seeded PRNG (Mulberry32). Integer state, integer outputs.
 * Rule: NEVER use Math.random() in sim logic (CLAUDE.md rule 3).
 */
export interface Rng {
  /** next uint32 */
  nextU32(): number
  /** integer in [0, bound) — bound must be >= 1 */
  nextInt(bound: number): number
  /** roll a percentage check: true with `chancePct` in [0,100] */
  rollPct(chancePct: number): boolean
}

export function createRng(seed: number): Rng {
  // force uint32 seed
  let a = seed >>> 0
  function nextU32(): number {
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t = (t + Math.imul(t ^ (t >>> 7), t | 61)) ^ t
    return (t ^ (t >>> 14)) >>> 0
  }
  return {
    nextU32,
    nextInt(bound: number): number {
      if (bound <= 1) return 0
      return nextU32() % bound
    },
    rollPct(chancePct: number): boolean {
      if (chancePct <= 0) return false
      if (chancePct >= 100) return true
      return nextU32() % 100 < chancePct
    },
  }
}
